import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { AmountHelper } from "src/helpers/AmountHelper";

export const StockTakingsDetailProducts = () => {
  const tableName = "products";
  const { setValue, getValues } = useFormContext();
  const { t } = useTranslation();

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
      newQuantity,
      getValues(`${tableName}.${index}.price`),
      getValues(`${tableName}.${index}.vatType`),
      getValues("priceIncludesVat")
    );
    setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    setValue(`${tableName}.${index}.amountWithVat`, newAmounts.amountWithVat);
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
      getValues(`${tableName}.${index}.quantity`),
      newPrice,
      getValues(`${tableName}.${index}.vatType`),
      getValues("priceIncludesVat")
    );
    setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    setValue(`${tableName}.${index}.amountWithVat`, newAmounts.amountWithVat);
  };
  return (
    <>
      <NFormTable fieldArray={"stocktakingGoods"}>
        <NFLookupProduct fieldName={"productId"} width={200} title={t("Product")} />
        <NFLookupUnit fieldName={"unitId"} title={t("Unit")} width={200} />
        <NFTextInput title={t("Article")} fieldName="article" />
        <NFIntInput fieldName="difference" title={t("Difference")} />
        <NFIntInput fieldName="amountOfDifference" title={t("AmountOfDifference")} />
        <NFIntInput fieldName="quantityFact" title={t("QuantityFact")} />
        <NFIntInput fieldName="accountingQuantity" title={t("AccountingQuantity")} />
        <NFIntInput fieldName="unitCost" title={t("UnitCost")} />
        <NFIntInput fieldName="actualAmount" title={t("ActualAmount")} />
        <NFIntInput fieldName="accountingAmount" title={t("AccountingAmount")} />
        <NFIntInput fieldName={"quantity"} onValueChanged={handleQuantityChanged} width={100} title={t("Quantity")} />
        <NFIntInput fieldName={"price"} onValueChanged={handlePriceChanged} width={100} title={t("Price")} />
        <NFIntInput fieldName={"amount"} width={100} title={t("Amount")} />
      </NFormTable>
    </>
  );
};
